import { Box, LinearProgress } from '@common-components';

export default function ReFetchLoader() {
  return (
    <Box className="find" position="fixed" top={0} left={0} right={0} zIndex={(theme) => theme.zIndex.tooltip}>
      <LinearProgress sx={{ width: 1, height: 2 }} />
    </Box>
  );
}
